<template>
  <div class="profile-popover">
    <div class="profile-popover-email">{{ user.emailAddress || user.email }}</div>
    <button class="popover-item" @click="go('/profile')">Mein Profil</button>
    <button class="popover-item" v-if="isAdmin" @click="go('/profile', { tab: 'plan' })">Plan ändern</button>
    <div class="popover-sep"></div>
    <button class="popover-item muted" @click="logout()">Abmelden</button>
  </div>
</template>
<script>
export default {
  computed: {
    user() { return this.$store.state.user || {}; },
    isAdmin() {
      const role = this.user.role;
      return role === 'admin' || role === 'super_admin';
    },
  },
  methods: {
    go(path, query) { this.$emit('close'); this.$router.push(query ? { path, query } : path); },
    logout() { this.$emit('close'); this.destroySession(); },
  },
  emits: ['close'],
}
</script>
